<template>
  <div class="white_background full-height">
    <div class="create-chapter-announcement">
      <v-layout class="create-chapter-announcement__header-section" justify-space-between row wrap>
        <v-flex sm6 xs12>
          <div class="create-chapter-announcement__title">{{ createChapterStudioConstant.PAGE_TITLE }}</div>
          <div class="create-chapter-announcement__subtitle">{{ pageSubTitle }}</div>
          <div v-if="breadCrumbList && breadCrumbList.length" class="create-chapter-announcement__breadcrumb">
            <ypo-breadcrumb :breadcrumb-list="breadCrumbList"></ypo-breadcrumb>
          </div>
        </v-flex>
        <v-flex class="text-right" sm6 xs12 v-if="!isMobilePreviewModeOpen">
          <v-btn class="create-chapter-announcement__cancel-btn mt-3" @click="handleCancel">
            <i class="fa-solid fa-close"></i>
            <span class="ml-2">{{ createChapterStudioConstant.CANCEL_BUTTON_LABEL }}</span>
          </v-btn>
        </v-flex>
      </v-layout>
      <div v-if="sectionMounted && !isMobilePreviewModeOpen" class="create-announcement-main__wrapper">
        <!--      TODO - this is actual create work is displayed -->
        <status-overlay :action="fetchingData" content-height="100px"></status-overlay>

        <div class="create-section">
          <v-expansion-panel v-model="sections.type" expand>
            <v-expansion-panel-content>
              <div slot="header" class="create-section__header">{{ createChapterStudioConstant.SECTIONS.TYPE }}</div>
              <div class="create-section__content">
                <create-announcement-type
                    :announcement-type="announcement.recordTypeName"
                    :background-color="announcement.backgroundColor"
                    :background-image="announcement.backgroundImage"
                    @selectedType="handleSelectedType">
                </create-announcement-type>
                <CreateAnnouncementImageUploader v-if="showImageUploader"
                                                 :background-color="announcement.backgroundColor"
                                                 :background-image="announcement.backgroundImage"
                                                 @imageBackgroundData="handleBackgroundData">
                </CreateAnnouncementImageUploader>
              </div>
              <div v-if="announcement.recordTypeName.toLowerCase() === createChapterStudioConstant.IMAGE.toLowerCase()">
                <div class="create-section__heading">{{ createChapterStudioConstant.FORM_FIELD.CTA_LINK }}</div>
                <div class="create-section__image-link-section">
                  <v-textarea v-model="announcement.ctaLink" :placeholder="createChapterStudioConstant.ENTER_CTA_LINK"
                              auto-grow class="cta-link-text-area"
                              outline rows="1"/>
                </div>
                <div class="create-section__heading">{{ createChapterStudioConstant.FORM_FIELD.LOCATION_OPTIONAL }}
                </div>
                <div class="create-section__image-link-section">
                  <v-text-field v-model="announcement.location"
                                :maxlength="createChapterStudioConstant.MAX_TEXT_LIMIT.LOCATION_LIMIT"
                                :placeholder="createChapterStudioConstant.ENTER_LOCATION" class="location-text-field"
                                hide-details/>
                </div>
                <CharacterCounter :currentLength="locationCharacterCount"
                                  :maxLength="createChapterStudioConstant.MAX_TEXT_LIMIT.LOCATION_LIMIT"/>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel class="mt-3" v-model="sections.sponsor">
            <v-expansion-panel-content>
              <div slot="header" class="create-section__header">{{ createChapterStudioConstant.SECTIONS.SPONSOR }}</div>
              <div v-if="!isWarningOrGeneral" class="create-section__sponsors-section">
                <span class="required-sponsor-text">{{ createChapterStudioConstant.SPONSOR_REQUIRED_MESSAGE }}</span>
                <v-select v-model="selectedDepartment" :items="departmentOptions"
                          :label="createChapterStudioConstant.SECTIONS.DEPARTMENTS" attach class="department__dropdown"
                          hide-details item-text="name"
                          :disabled="!departmentOptions.length"
                          outline @change="onDepartmentChange">
                </v-select>
                <span class="span-or">OR</span>
                <v-select v-model="selectedRegions" :items="regionOptions"
                          :label="createChapterStudioConstant.SECTIONS.REGIONS" attach class="region__dropdown"
                          hide-details item-text="name"
                          multiple outline @change="onRegionChange">
                  <template v-slot:selection="{ item, index }">
                    <span v-if="index === 0">{{ item }}</span>
                    <span v-if="index === 1" class="grey--text text-caption">
                      &nbsp;(+{{ selectedRegions.length - 1 }} others)
                    </span>
                  </template>
                </v-select>
              </div>
              <div class="create-section__visibleto-dropown">
                <v-select v-model="announcement.visibleToObject" :items="visibleToOptions"
                          :label="createChapterStudioConstant.SECTIONS.VISIBLE_TO" attach class="visibleto__dropdown"
                          hide-details
                          item-text="name"
                          return-object
                          outline/>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel v-model="sections.title" class="mt-3">
            <v-expansion-panel-content>
              <div slot="header" class="create-section__header">{{ createChapterStudioConstant.SECTIONS.TITLE }}</div>
              <div class="create-section__announcement-title_section">
                <v-text-field v-model="announcement.title"
                              :maxlength="createChapterStudioConstant.MAX_TEXT_LIMIT.TITLE_LIMIT"
                              :placeholder="createChapterStudioConstant.ENTER_TITLE"
                              class="announcement-title-text-field"
                              hide-details/>
                <CharacterCounter :currentLength="announcement.title.length"
                                  :maxLength="createChapterStudioConstant.MAX_TEXT_LIMIT.TITLE_LIMIT"/>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel v-model="sections.shortDescription" class="mt-3">
            <v-expansion-panel-content>
              <div slot="header" class="create-section__header">{{ createChapterStudioConstant.SECTIONS.SHORT_DESC }}
              </div>
              <div class="create-section__preview-desc-section">
                <v-textarea v-model="announcement.shortDescription"
                            :maxlength="createChapterStudioConstant.MAX_TEXT_LIMIT.SHORT_DESC_LIMIT"
                            :placeholder="createChapterStudioConstant.ENTER_PREVIEW_DESCRIPTION" :rows="calculatedRows"
                            auto-grow
                            class="preview-desc-field"
                            outline/>
                <CharacterCounter :currentLength="announcement.shortDescription.length"
                                  :maxLength="createChapterStudioConstant.MAX_TEXT_LIMIT.SHORT_DESC_LIMIT"/>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <div v-if="isWarningOrGeneral">
          <v-expansion-panel class="mt-3" v-model="sections.longDescription">
            <v-expansion-panel-content>
              <div slot="header" class="create-section__header">{{ createChapterStudioConstant.SECTIONS.LONG_DESC }}</div>
            <div class="create-section__modal-editor">
            <ck-editor :editor-id="ckEditorId"
                       :editor-type="ckEditorType.BASIC"
                       :auto-focus="false"
                       v-model="announcement.longDescription" height="350">
            </ck-editor>
          </div>
          <CharacterCounter :currentLength="longDescriptionCount"
                            :has-error="errorInLongDescriptionCount"
                            :error-message="createChapterStudioConstant.ERROR_MESSAGE.CHARACTER_LIMIT"
                            :maxLength="createChapterStudioConstant.MAX_TEXT_LIMIT.LONG_DESC_LIMIT" />
            </v-expansion-panel-content>
          </v-expansion-panel>
        </div>
        <v-expansion-panel class="mt-3" v-model="sections.scheduler">
          <v-expansion-panel-content>
              <div slot="header" class="create-section__header">{{ createChapterStudioConstant.SECTIONS.SCHEDULER }}
              </div>
              <div>
              <schedule-announcement
                  :announcement="announcement"
                  @emitEffectiveDateRange="updateScheduleDates"
                  @emitDisplayDateRange="updateScheduleDates"
              />
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
        </div>

        <div class="action-bar--wrapper">
          <div v-if="!canPublish" class="action-bar__publish-disclaimer">{{ createChapterStudioConstant.PUBLISH_REQUIRED_DISCLAIMER }}
          </div>
          <v-layout class="action-bar__main" row>
            <v-btn class="action-bar__secondary-btn" :disabled="!canPublish" @click="handleSaveDraft">{{ createChapterStudioConstant.ACTION.SAVE_DRAFT }}</v-btn>
            <v-btn class="action-bar__secondary-btn action-bar__secondary-btn--desktop" @click="togglePreviewDialogMode">
              {{ createChapterStudioConstant.ACTION.PREVIEW }}
            </v-btn>
            <v-btn class="action-bar__secondary-btn action-bar__secondary-btn--mobile" @click="toggleMobilePreviewMode">
              {{ createChapterStudioConstant.ACTION.PREVIEW }}
            </v-btn>
            <v-btn :disabled="!canPublish" class="action-bar__primary-btn" @click="handlePublish">
              {{ createChapterStudioConstant.ACTION.PUBLISH }}
            </v-btn>
          </v-layout>
        </div>

        <v-dialog v-model="isPreviewModalOpen"
                  v-if="!isMobilePreviewModeOpen"
                  class="create-chapter-announcement__preview-dialog"
                  content-class="medium"
                  persistent
                  scrollable>
          <preview-announcement
              :announcement="announcement"
              :back-action="togglePreviewDialogMode"
              :can-publish="canPublish"
              :publish-action="handlePublish"
              :save-draft-action="handleSaveDraft"></preview-announcement>
        </v-dialog>
      </div>
      <div class="create-chapter-announcement__preview-mobile" v-if="isMobilePreviewModeOpen">
        <preview-announcement
            :announcement="announcement"
            :back-action="toggleMobilePreviewMode"
            :can-publish="canPublish"
            :publish-action="handlePublish"
            :save-draft-action="handleSaveDraft"></preview-announcement>
      </div>
    </div>
  </div>
</template>

<script>

import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { storeGetters } from "@/store/storeGetters.constant";
import { storeAction } from "@/store/storeActions.constant";
import StatusOverlay from "@/components/StatusOverlay/StatusOverlay.vue";
import {
  announcementSections,
  createChapterStudioConstant,
  getDefaultAnnouncementObj,
  manageChapterStudioConstant,
  createAnnouncementFormData,
} from "@/components/ChapterStudioPageManage/manageChapterStudio.constant";
import YpoBreadcrumb from "@/components/YpoBreadcrumb/YpoBreadcrumb.vue";
import { routerNames } from "@/components/appCommon.constants";
import CreateAnnouncementType from "@/components/ChapterStudioPageManage/CreateAnnouncementType.vue";
import CharacterCounter from "@/components/ChapterStudioPageManage/CharacterCounter.vue";
import CreateAnnouncementImageUploader from "@/components/ChapterStudioPageManage/CreateAnnouncementImageUploader.vue";
import ckEditor from "../CkEditor/CkEditor";
import { ckEditorType } from "@/plugins/CkEditor/ckEditorTypes.config";
import { getRandomId } from '@/common/utils/utils';
import PreviewAnnouncement from "@/components/ChapterStudioPageManage/PreviewAnnouncement.vue";
import ScheduleAnnouncement from '@/components/ChapterStudioPageManage/ScheduleAnnouncement.vue';

export default {
  name: 'CreateAnnouncement',
  components: {
    PreviewAnnouncement,
    CreateAnnouncementImageUploader,
    CreateAnnouncementType,
    YpoBreadcrumb,
    StatusOverlay,
    CharacterCounter,
    ckEditor,
    ScheduleAnnouncement,
  },
  data() {
    return {
      createChapterStudioConstant,
      manageChapterStudioConstant,
      announcement: getDefaultAnnouncementObj(),
      sections: announcementSections(),
      sectionMounted: false,
      selectedDepartment: null,
      selectedRegions: [],
      ckEditorType,
      ckEditorId: getRandomId(),
      isPreviewModalOpen: false,
      isMobilePreviewModeOpen: false,
    };
  },
  props: {},
  async created() {
    await this.getChapterStudioPicklists();
    if (this.announcementId) {
      if (this.announcementFromStore) {
        this.announcement = { ...this.announcementFromStore };
      } else {
        this.announcement = await this.getChapterStudioAnnouncementById(this.announcementId);
      }
      this.initializeEditData();
    }
    this.sections = announcementSections(this.$vuetify.breakpoint.xs);
    this.sectionMounted = true;
  },
  methods: {
    ...mapActions({
      getChapterStudioPicklists: `manageChapterStudio/${storeAction.getChapterStudioPicklists}`,
      getChapterStudioAnnouncementById: `manageChapterStudio/${storeAction.getChapterStudioAnnouncementById}`,
      saveChapterStudioAnnouncement: `manageChapterStudio/${storeAction.saveChapterStudioAnnouncement}`,
    }),
    ...mapActions('snackbar', [
      `${storeAction.setToastMessage}`,
      `${storeAction.hideSnackbar}`,
    ]),
    ...mapMutations({}),
    handleCancel() {
      this.$router.push(`/${routerNames.MANAGE_CHAPTER_STUDIO}`);
    },
    handleSelectedType(announcementType) {
      this.announcement.recordTypeName = announcementType;
    },
    handleBackgroundData(data) {
      this.announcement = { ...this.announcement, ...data };
    },
    onDepartmentChange() {
      if (this.selectedDepartment.length) {
        this.selectedRegions = [];
        this.announcement.sponsorRegionsList = null;
        this.announcement.sponsorDepartmentList = [this.selectedDepartment];
      }
    },
    onRegionChange(newSelection) {
      if (newSelection.length > 4) {
        const lastItemOfLocal = this.selectedRegions[3];
        this.selectedRegions = newSelection.filter(item => item !== lastItemOfLocal);
      } else {
        this.selectedRegions = newSelection;
      }
      this.announcement.sponsorRegionsList = [...this.selectedRegions];
      this.selectedDepartment = null;
      this.announcement.sponsorDepartmentList = null;
    },
    initializeEditData() {
      if (this.announcement) {
        if (this.announcement.sponsorRegionsList && this.announcement.sponsorRegionsList.length) {
          this.selectedRegions = [...this.announcement.sponsorRegionsList];
        } else if (this.announcement.sponsorDepartmentList && this.announcement.sponsorDepartmentList.length) {
          this.selectedDepartment = this.announcement.sponsorDepartmentList[0];
        }
      }
      this.announcement.displayStartDate = this.formatDate(this.announcement.displayStartDate);
      this.announcement.displayEndDate = this.formatDate(this.announcement.displayEndDate);
      this.announcement.effectiveStartDate = this.formatDate(this.announcement.effectiveStartDate);
      this.announcement.effectiveEndDate = this.formatDate(this.announcement.effectiveEndDate);
    },
    formatDate(dateString) {
      if (dateString) {
        const date = new Date(dateString);
        return date.toISOString().slice(0, 10);
      }
      return '';
    },
    togglePreviewDialogMode() {
      this.isPreviewModalOpen = !this.isPreviewModalOpen;
    },
    toggleMobilePreviewMode() {
      this.isMobilePreviewModeOpen = !this.isMobilePreviewModeOpen;
    },
    validateAnnouncementFields() {
        const {
            backgroundColor,
            backgroundImage,
            ctaLink,
            displayEndDate,
            displayStartDate,
            shortDescription,
            visibleToObject,
            title,
            sponsorDepartmentList,
            sponsorRegionsList, 
            }  = this.announcement;
        let requiredFields = [];
        if (this.isWarningOrGeneral) {
            this.announcement.sponsorDepartmentList = null;
            this.announcement.sponsorRegionsList = null;
            
            requiredFields = [displayEndDate, displayStartDate, shortDescription, visibleToObject, title];
        } else {
            requiredFields = [
                backgroundColor || backgroundImage,
                ctaLink, displayEndDate, displayStartDate, shortDescription, visibleToObject, title,
                sponsorDepartmentList || sponsorRegionsList,
            ];
        }
        return requiredFields.every(field => field !== null && field !== undefined && field !== "");
    },
    handlePublish() {
     if(this.validateAnnouncementFields()) {
      this.announcement.isPublished = true;
        const formData = createAnnouncementFormData(this.announcement);
        this.saveChapterStudioAnnouncement(formData)
        .then(() => {
            this.setToastMessage({
              color: 'success',
              message: this.createChapterStudioConstant.SUCCESS_MESSAGE.PUBLISHED_SUCCESS,
            });
            this.$router.push(`/${routerNames.MANAGE_CHAPTER_STUDIO}`);
          })
          .catch(() => {
            this.setToastMessage({
              color: 'error',
              message: this.createChapterStudioConstant.ERROR_MESSAGE.ANNOUNCEMENT_FAILURE,
            });
          });
       }
    },
    handleSaveDraft() {
        this.announcement.isPublished = false;
        const formData = createAnnouncementFormData(this.announcement);
        this.saveChapterStudioAnnouncement(formData)
        .then(() => {
            this.setToastMessage({
              color: 'success',
              message: this.createChapterStudioConstant.SUCCESS_MESSAGE.DRAFT_SUCCESS,
            });
            this.$router.push(`/${routerNames.MANAGE_CHAPTER_STUDIO}`);
          })
          .catch(() => {
            this.setToastMessage({
              color: 'error',
              message: this.createChapterStudioConstant.ERROR_MESSAGE.ANNOUNCEMENT_FAILURE,
            });
          });
    },
    updateScheduleDates(updatedValue) {
      this.announcement = {
        ...this.announcement,
        ...updatedValue,
      };
    },
  },
  computed: {
    ...mapState('actionState', ['actions']),
    ...mapGetters({
      manageChapterStudioAllAnnouncements: `manageChapterStudio/${storeGetters.manageChapterStudioAllAnnouncements}`,
      manageChapterStudioBreadcrumbs: `manageChapterStudio/${storeGetters.manageChapterStudioBreadcrumbs}`,
      chapterStudioPicklists: `manageChapterStudio/${storeGetters.chapterStudioPicklists}`,
      announcementFromState: `manageChapterStudio/${storeGetters.announcementFromState}`,
    }),
    fetchingData() {
      return this.actions[storeAction.getChapterStudioAnnouncementById || storeAction.getChapterStudioPicklists];
    },
    announcementId() {
      return this.$route.params && this.$route.params.announcementId ? this.$route.params.announcementId : null;
    },
    announcementFromStore() {
      return this.announcementId ? this.announcementFromState(this.announcementId) : null;
    },
    breadCrumbList() {
      let result = [...this.manageChapterStudioBreadcrumbs];
      if (this.announcementId && result.length) {
        result = result.map((crumb) => {
          return {
            ...crumb,
            text: crumb.key === routerNames.CREATE_ANNOUNCEMENT ? createChapterStudioConstant.EDIT_ANNOUNCEMENT_BREADCRUMB : crumb.text,
          };
        });
      }
      return result;
    },
    pageSubTitle() {
      return this.announcementId ? createChapterStudioConstant.EDIT_ANNOUNCEMENT_BREADCRUMB : createChapterStudioConstant.PAGE_SUBTITLE;
    },
    departmentOptions() {
      if(this.chapterStudioPicklists.departments) {
        return this.chapterStudioPicklists.departments;
      }
      return [];
    },
    regionOptions() {
      return this.chapterStudioPicklists.regions.map(reg => reg.name);
    },
    visibleToOptions() {
      return this.chapterStudioPicklists.visibleTo;
    },
    showImageUploader() {
      return this.announcement.recordTypeName === this.createChapterStudioConstant.RECORD_TYPE.IMAGE;
    },
    calculatedRows() {
      if (this.$vuetify.breakpoint.xs) {
        const { length } = this.announcement.shortDescription;
        if (length > 88) {
          return 3;
        } else if (length > 40) {
          return 2;
        }
      }
      return 1;
    },
    isWarningOrGeneral() {
      const recordType = this.announcement.recordTypeName.toLowerCase();
      const warning = this.createChapterStudioConstant.RECORD_TYPE.WARNING.toLowerCase();
      const general = this.createChapterStudioConstant.RECORD_TYPE.GENERAL.toLowerCase();
      return recordType === warning || recordType === general;
    },
    canPublish() {
        return this.validateAnnouncementFields();
    },
    longDescriptionCount() {
      let longDWithoutTags = this.announcement.longDescription.replace(/<[^>]*>/g, '');
      longDWithoutTags = longDWithoutTags.replace('\n', '');
      longDWithoutTags = longDWithoutTags.replace('\t', '');
      longDWithoutTags = longDWithoutTags.replace(/&nbsp;/g, " ");
      return longDWithoutTags.length;
    },
    errorInLongDescriptionCount() {
      return this.longDescriptionCount > 1000;
    },
    locationCharacterCount() {
      return (this.announcement.location || "").length;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../common/styles/_colors.scss";
@import "../../common/styles/_responsive.scss";
@import "../../common/styles/_commonClasses.scss";

.create-chapter-announcement {
  font-family: Roboto, 'sans-serif';
  max-width: 100%;
  min-height: 350px;
  margin: 64px auto 0;
  background-color: $white;

  &__header-section {
    padding: 15px 25px 0;

    @include breakpointMin(md) {
      padding: 25px 50px 0;
    }
  }

  @include breakpointMin(sm) {
    max-width: 1221px;
  }

  &__title {
    font-size: 36px;
    font-weight: 600;
    line-height: 42.19px;
    height: 42px;
    color: $ypo-blue;
  }

  &__subtitle {
    font-size: 28px;
    font-weight: 400;
    height: 33px;
    line-height: 32.81px;
    padding-top: 3px;
    color: $ypo-blue;
  }

  &__breadcrumb {
    padding-top: 10px;
  }

  &__cancel-btn {
    font-family: sans-serif;
    background-color: $mild-grey !important;
    color: $white;
    font-size: 15px;
    font-weight: bold;
    text-transform: uppercase;
    border-radius: 8px;
    height: 32px;
    width: 100%;
    margin-left: 0;
    padding-left: 20px;

    @include breakpointMin(sm) {
      width: 129px;
      padding: 10px
    }

    i {
      display: block;
      padding-right: 10px;

      @include breakpointMin(sm) {
        display: none;
      }
    }
  }

  .create-announcement-main {
    &__wrapper {
      position: relative;

      @include breakpointMin(sm) {
        padding: 0 25px;
      }

      @include breakpointMin(md) {
        padding: 0 50px;
      }
    }
  }

  .create-section {
    margin-bottom: 70px;

    &__header {
      font-size: 18px;
      font-weight: 600;
      color: $ypo-blue;

      @include breakpointMin(sm) {
        font-size: 24px;
      }
    }

    &__divider {
      padding-top: 10px;
      border-bottom: 1px solid $ypo-solitude-gray;

      @include breakpointMin(sm) {
        display: none;
      }
    }

    &__heading {
      font-size: 18px;
      font-weight: 600;
      line-height: 28px;
      color: $ypo-blue;
      padding-top: 15px;

      @include breakpointMin(sm) {
        font-size: 24px;
      }
    }

    &__image-link-section {
      display: flex;
      flex-direction: column;

      .location-text-field {
        border: 1px solid $mild-grey !important;
        font-size: 14px;
        font-weight: 500;
        margin-bottom: 4px;
        padding: 12px !important;
        background-color: white;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        margin-top: 6px;

        @include breakpointMin(sm) {
          border-radius: 0px;
        }
      }

      .cta-link-text-area {
        border: 1px solid $mild-grey !important;
        font-size: 14px;
        font-weight: 500;
        background-color: white;
        color: $ypo-blue;
        border-radius: 8px;
        margin-top: 6px;
        min-height: 40px;

        @include breakpointMin(sm) {
          border-radius: 0px;
        }
      }
    }

    &__announcement-title_section {

      .announcement-title-text-field {
        border: 1px solid $mild-grey !important;
        font-size: 14px;
        font-weight: 500;
        height: 50px;
        margin-bottom: 4px;
        padding: 12px !important;
        background-color: white;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        margin-top: 4px;

        @include breakpointMin(sm) {
          border-radius: 0px;
          margin-top: 0px;
        }
      }
    }

    &__preview-desc-section {
      .preview-desc-field {
        border: 1px solid $mild-grey !important;
        font-size: 14px;
        font-weight: 500;
        background-color: white;
        color: $ypo-blue;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;

        @include breakpointMin(sm) {
          border-radius: 0px;
          margin-top: 2px;
        }

      }
    }

    &__sponsors-section {
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      min-width: 250px;
      margin-top: 10px;
      margin-bottom: 10px;

      @include breakpointMin(sm) {
        flex-direction: row;
        max-width: 700px;
      }

      .span-or {
        margin: 10px 10px;
        font-size: 16px;
        font-weight: bold;
        display: none;
        padding: 8px;

        @include breakpointMin(sm) {
          display: block;
        }
      }

      .required-sponsor-text {
        margin-top: -10px;
        margin-left: -8px;
        text-align: left;
        font-size: 12px;
        font-weight: 600;
        display: block;
        padding: 8px;

        @include breakpointMin(sm) {
          display: none;
        }
      }

      .department__dropdown {
        border-radius: 8px;
        font-size: 12px;
        margin-bottom: 10px;

        @include breakpointMin(sm) {
          max-width: calc(50%);
        }
      }

      .region__dropdown {
        border-radius: 8px;
        font-size: 12px;

          @include breakpointMin(sm) {
            display: block;
          }
        }
        .required-sponsor-text {
          margin-top: -10px;
          margin-left: -8px;
          text-align: left;
          font-size: 12px;
          font-weight: 600;
          display: block;
          padding: 8px;

          @include breakpointMin(sm) {
            display: none;
          }
        }
        .department__dropdown {
          border-radius: 8px;
          font-size: 12px;
          margin-bottom: 10px;

          @include breakpointMin(sm) {
            width: calc(50%);
          }
        }
        .region__dropdown {
          border-radius: 8px;
          font-size: 12px;

          @include breakpointMin(sm) {
            width: calc(50%);
          }
        }
      }

    &__visibleto-dropown {
          border-radius: 8px;
          font-size: 12px;
          max-width: 700px;
          margin-bottom: 10px;
    }
    &__modal-editor {
          border: 1px solid $mild-grey !important;
          border-top-right-radius: 8px;
          border-top-left-radius: 8px;

          @include breakpointMin(sm) {
            border-top-right-radius: 0px !important;
            border-top-left-radius: 0px !important;
        }
    }
  }

  .action-bar {
    &--wrapper {
      padding-top: 5px;
      position: static;
      bottom: 0;
      width: 100%;
      background-color: $white;
    }

    &__publish-disclaimer {
      color: $ypo-error-red;
      font-size: 10px;
      font-weight: 500;
      padding: 0 20px;

      @include breakpointMin(sm) {
        text-align: right;
        padding: 0;
      }
    }

    &__main {
      flex-direction: column-reverse;
      padding: 5px 20px;

      @include breakpointMin(sm) {
        flex-direction: row;
        justify-content: end;
        align-items: end;
        padding-right: 0;
      }
    }

    &__secondary-btn {
      background: $mild-grey !important;
      color: $white !important;
      border-radius: 8px;
      padding: 8px 28px;
      width: 100%;
      height: 32px;
      font-size: 14px;
      font-weight: 600;
      box-shadow: none !important;
      margin: 5px 0;

      @include breakpointMin(sm) {
        width: 190px;
        margin: 5px 10px;
      }

      &--desktop {
        display: none;

        @include breakpointMin(sm) {
          display: flex;
        }
      }

      &--mobile {
        @include breakpointMin(sm) {
          display: none;
        }
      }
    }

    &__primary-btn {
      background: $ypo-brand-blue !important;
      color: $white !important;
      border-radius: 8px;
      padding: 8px 28px;
      width: 100%;
      height: 32px;
      font-size: 14px;
      font-weight: 600;
      box-shadow: none !important;
      margin: 5px 0;

      @include breakpointMin(sm) {
        width: 190px;
        margin: 5px 0  5px 10px;
      }
    }
  }

  &__preview-dialog {
    height: auto;
    display: none !important;

    @include breakpointMin(sm) {
      display: block;
    }
  }

  &__preview-mobile {
    @include breakpointMin(sm) {
      display: none;
    }
  }

}
</style>

<style lang="scss">
@import "../../common/styles/_responsive.scss";

.create-chapter-announcement {
  height: 100%;

  &__cancel-btn {
    .v-btn__content {
      justify-content: flex-start;

      @include breakpointMin(sm) {
        justify-content: center;
      }
    }
  }

  .v-expansion-panel {
    box-shadow: none;
  }

  .create-section {
    padding-top: 10px;

    .v-expansion-panel {
      &__header {
        min-height: 30px;
        padding: 0 25px 5px;
        border-bottom: 1px solid #DEDEDE;

        @include breakpointMin(sm) {
          padding: 0 0 5px;
          pointer-events: none;
          border-bottom: none;
        }

        &__icon {
          @include breakpointMin(sm) {
            display: none;
          }
        }
      }

      &__body {
        background-color: $ypo-blue-blush;
        padding: 10px 25px;

        @include breakpointMin(sm) {
          padding: 0;
          background-color: transparent;
        }
      }
    }

    &__image-link-section, &__preview-desc-section, &__announcement-title_section, &__visibleto-dropown {
      .v-textarea {
        .v-input__slot {
          min-height: 4px;
          border: none;
          overflow: hidden;

          &:hover {
            border: none !important;
          }
        }

        .v-input__control textarea {
          overflow-y: scroll;
          -ms-overflow-style: none;
          resize: none;
        }

        .v-input__control textarea::-webkit-scrollbar {
          display: none;
        }

        &.v-text-field--box .v-text-field__prefix,
        &.v-text-field--enclosed .v-text-field__prefix,
        &.v-text-field--box textarea,
        &.v-text-field--enclosed textarea {
          margin-top: 5px !important;
        }

        &.v-text-field.v-text-field--enclosed .v-text-field__details {
          display: none;
        }
      }

      .v-text-field {
        input {
          padding: 0px 0 8px;
        }

        .v-input__slot::after, ::before {
          border-style: none !important;
        }
      }
    }

    &__sponsors-section, &__visibleto-dropown {
      .v-select {
        .v-input__control {
          .v-input__slot {
            border: 1.3px solid $mild-grey;
            border-radius: 8px;
            background-color: white !important;

            .v-select__slot {
              .v-label {
                font-size: 12px;
                font-family: Roboto, 'sans-serif';
              }
            }
          }

          &:hover .v-input__slot {
            border: 1.3px solid $mild-grey !important;
          }
        }

        .theme--light.v-text-field--outline:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot:hover {
          border: 1.3px solid $mild-grey !important;
        }

        .v-select__selection--comma {
          font-size: 12px;
        }

        .v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
          margin-bottom: 0px;
          border-style: none;
        }

        .v-input--selection-controls:not(.v-input--hide-details) .v-input__slot:hover {
          border-style: none !important;
        }
      }

      .v-text-field.v-text-field--enclosed .v-text-field__details {
        margin-bottom: 8px;
      }
    }
    .ck-editor .cke_top {
      border-top-right-radius: 8px !important;
      border-top-left-radius: 8px !important;

      @include breakpointMin(sm) {
        border-top-right-radius: 0px !important;
        border-top-left-radius: 0px !important;
      }
    }
    .cke_contents {
      padding: 0 10px;
      border-bottom: 1px solid $mild-grey;
      height: 350px !important;
      overflow-y: hidden !important;
    }
    .cke_bottom {
      display: none;
      border-bottom: 1px solid $mild-grey;
    }
    .cke_inner {
      border-top-right-radius: 8px !important;
      border-top-left-radius: 8px !important;

      @include breakpointMin(sm) {
        border-top-right-radius: 0px !important;
        border-top-left-radius: 0px !important;
      }
    }
  }
}
</style>
